import { LockRounded } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { LockOpenRoundedIcon } from 'app/icons';
import React, { forwardRef } from 'react';

const IconButtonComponent = forwardRef((props, ref) => <div ref={ref} {...props} />);

export const GuardButton = ({
  isLocked,
  disabled,
  onToggle,
  guardDisabled,
  tooltipTitle = 'Перейдите на последнее состояние',
  size = 'small',
}) => {
  // Если нет устройства или данных - показываем disabled кнопку
  if (disabled && !onToggle) {
    return (
      <IconButton size={size} disabled>
        <LockRounded fontSize={size} />
      </IconButton>
    );
  }

  const LockIcon = isLocked ? LockRounded : LockOpenRoundedIcon;
  const color = isLocked ? 'primary' : 'inherit';
  const title = guardDisabled ? tooltipTitle : '';

  return (
    <Tooltip title={title} placement='top' disableInteractive arrow>
      <IconButtonComponent>
        <IconButton size={size} color={color} disabled={disabled || guardDisabled} onClick={onToggle}>
          <LockIcon fontSize={size} />
        </IconButton>
      </IconButtonComponent>
    </Tooltip>
  );
};
